module.exports = __webpack_public_path__ + "img/datospersonales.7f79d7f3.png";